import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const nav = css`
  max-width: 100%;
  overflow-x: auto;
  padding-bottom: ${size[16]};
`

export const list = css`
  display: flex;
  padding: 0;
  margin: 0;
  list-style-type: none;
`
